import axios from "../plugins/parseAxios";
export class CreditNoteAPI {

  static getCreditNote(postData) {
    return axios.post("functions/getCreditNote", postData);
  }
  static getCreditNotes(postData) {
    return axios.post("functions/getCreditNotes", postData);
  }
  static getCreditNotesBetweenDateByMarket(postData) {
    return axios.post("functions/getCreditNotesBetweenDateByMarket", postData);
  }
  static getCreditNotesBetweenDateByProject(postData) {
    return axios.post("functions/getCreditNotesBetweenDateByProject", postData);
  }
  static createCreditNote(postData) {
    return axios.post("functions/createCreditNote", postData);
  }
  static updateCreditNote(postData) {
    return axios.post("functions/updateCreditNote", postData);
  }
  static sendCreditNote(postData) {
    return axios.post("functions/sendCreditNote", postData);
  }
  static unsendCreditNote(postData) {
    return axios.post("functions/unsendCreditNote", postData);
  }
  static getCreditNoteData(postData) {
    return axios.post("functions/getCreditNoteData", postData);
  }
}
